// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import { Turbo } from "@hotwired/turbo-rails"
import { showConfirmModal } from "./custom_confirm"
import "./controllers"

Turbo.config.forms.confirm = showConfirmModal

// Prevent double form submissions by disabling buttons during Turbo requests
document.addEventListener("turbo:submit-start", (event) => {
  const form = event.target
  const buttons = form.querySelectorAll("button, input[type=submit]")
  buttons.forEach(button => {
    button.disabled = true
    button.dataset.wasDisabled = "true"
  })
})

document.addEventListener("turbo:submit-end", (event) => {
  const form = event.target
  const buttons = form.querySelectorAll("[data-was-disabled]")
  buttons.forEach(button => {
    button.disabled = false
    delete button.dataset.wasDisabled
  })
})

// Prevent rapid link clicks from creating multiple pending requests
let isNavigating = false

document.addEventListener("turbo:before-visit", () => {
  isNavigating = true
})

document.addEventListener("turbo:load", () => {
  isNavigating = false
})

document.addEventListener("turbo:render", () => {
  isNavigating = false
})

document.addEventListener("turbo:fetch-request-error", () => {
  isNavigating = false
})

document.addEventListener("turbo:before-fetch-response", () => {
  isNavigating = false
})

// Handle stale CSRF tokens (e.g., session expired overnight).
// The server responds with 419 when the CSRF token is invalid;
// reload so the browser gets a fresh token.
document.addEventListener("turbo:before-fetch-response", (event) => {
  const response = event.detail.fetchResponse.response
  if (response.status === 419) {
    event.preventDefault()
    window.location.reload()
  }
})

// Intercept link clicks during navigation
document.addEventListener("click", (event) => {
  if (!isNavigating) return

  const link = event.target.closest("a[href]")
  if (link && !link.hasAttribute("data-turbo-frame") && !link.hasAttribute("target") && !link.hasAttribute("data-turbo-method")) {
    event.preventDefault()
    event.stopPropagation()
  }
}, true)

// Register the service worker backing the PWA install and the offline page.
// It is served from /service-worker.js so its scope covers the whole site.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch((error) => {
      console.error("Service worker registration failed:", error)
    })
  })
}
